import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
interface S3UploadResponse {
  fileName: string;
  signedUrl: string;
  fileNameWithAttachId: string;
  attachId: number;
}
type S3UploadRequest = string[];
const useReceiptS3UploadApi = () => {
  const call = useCallback(
    (body: S3UploadRequest = []) =>
      axiosInstance
        .post<S3UploadResponse[]>(api.getReceiptUploadS3UrlFn(), body)
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
    []
  );
  const { execute, isLoading } = useAsync(call, false);
  return {
    S3Files: execute,
    isS3ReceiptFileUploading: isLoading,
  };
};
export default useReceiptS3UploadApi;
